import './App.css';
import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, RouterProvider, createHashRouter } from "react-router-dom";
import Home from "./pages/home";
import Detail from "./pages/detail";
import DetailMNL from "./pages/detailMNL";
import DetailMCB from './pages/detailMCB';
import DetailPK from './pages/detailPK';
import THeader from "./components/THeader";
import TFooter from "./components/TFooter";

// 🔥 Lazy load các trang Admin
const Admin = lazy(() => import("./pages/admin"));
const AdminMCB = lazy(() => import("./pages/adminMCB"));
const AdminMNL = lazy(() => import("./pages/adminMNL"));
const AdminPK = lazy(() => import("./pages/adminPK"));

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/mauthietke", element: <Detail /> },
  { path: "/maukhonglogo", element: <DetailMNL /> },
  { path: "/maucaulacbo", element: <DetailMCB /> },
  { path: "/phukien", element: <DetailPK /> },

  // 👇 các route Admin chỉ load khi cần
  { path: "/xadmin/mtk", element: <Admin /> },
  { path: "/xadmin/mcb", element: <AdminMCB /> },
  { path: "/xadmin/mnl", element: <AdminMNL /> },
  { path: "/xadmin/pk", element: <AdminPK /> }
]);

function App() {
  return (
    <>
      <div className="container">
        <div className="App">
          <THeader />
          <div style={{ display: 'flex', width: '100%', height: 5, marginTop: 58 }} />

          {/* 🌀 Suspense để hiển thị khi đang tải */}
          <Suspense fallback={<div style={{ textAlign: 'center', padding: 20 }}>Đang tải...</div>}>
            <RouterProvider router={router} />
          </Suspense>
        </div>
      </div>

      <div style={{ width: '100%' }}>
        <TFooter />
      </div>
    </>
  );
}

export default App;
